(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"]) return;
  try {
    
(() => {
  if (customElements.get('alx-announcement-countdown')) return;
  customElements.define('alx-announcement-countdown', class extends HTMLElement {
    connectedCallback() {
      this.deadline = Date.parse(this.dataset.end);
      this.tick();
      if (Number.isFinite(this.deadline) && this.deadline > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    tick() {
      const remaining = Math.max(0, Math.floor((this.deadline - Date.now()) / 1000));
      this.hidden = !Number.isFinite(this.deadline) || remaining === 0;
      if (this.hidden) { clearInterval(this.interval); return; }
      const days = Math.floor(remaining / 86400);
      const hours = String(Math.floor(remaining / 3600) % 24).padStart(2, '0');
      const minutes = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
      const seconds = String(remaining % 60).padStart(2, '0');
      this.textContent = `${this.dataset.label} ${days ? `${days}${this.dataset.day} ` : ''}${hours}:${minutes}:${seconds}`;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
